import {Component, Input, OnInit} from '@angular/core';
import {ProjectService} from '../../../shared/services/project/project.service';
import {NotationService} from '../../../shared/services/notation/notation.service';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {AgmMarker} from '@agm/core/';
import {IconService} from '../../../shared/services/icon/icon.service';

@Component({
  selector: 'app-project-location-map',
  templateUrl: './project-location-map.component.html',
  styleUrls: ['./project-location-map.component.scss']
})
export class ProjectLocationMapComponent implements OnInit {

  title = 'app';
  mapCenter: google.maps.LatLngLiteral;
  currentMapCenter: google.maps.LatLngLiteral;
  fitBounds: boolean = true;
  markers: any[];
  plans: any[];
  showSpinner: boolean = false;
  mapOpacity: number;
  idProject: any;
  projectName: string;
  expanded: boolean = true;
  selectedView: 1 | 2 | 3 = 1;

  @Input() readOnly: boolean;
  @Input() test: string;

  selectedPlanIndex: number = 0;

  constructor(
    public iconService: IconService,
    private projectService: ProjectService,
    private notationService: NotationService,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.idProject = this.route.snapshot.paramMap.get('idProject');
    this.initComponent();
  }

  initComponent() {
    this.showSpinner = true;
    this.mapOpacity = 0.3;
    this.projectService.getProject(this.idProject, 'locations,notations,plans')
      .subscribe(
        (project: any) => {
          let newProjectDeviceLocations = [];
          project.project_device_locations.forEach(pdl => {
            if (pdl.active === true) {
              if (pdl.children) {
                let newProjectDeviceLocationsChild = [];
                pdl.children.forEach(child => {
                  if (child.active === true) {
                    newProjectDeviceLocationsChild.push(child);
                  }
                });
                pdl.children = newProjectDeviceLocationsChild;
              }
              newProjectDeviceLocations.push(pdl);
            }
          });
          project.project_device_locations = newProjectDeviceLocations;

          this.projectName = project.name;
          let formattedDevices = this.notationService.addIconUrlsToDevices(project.project_device_locations, project.note_project_users_current);
          this.markers = this.notationService.orderDevices(formattedDevices);
          this.plans = project.project_plans
            .filter(
              (plan) => plan.active && plan.image_name
            )
            .map(
              (plan) => {
                plan.url = environment.apiUrl + 'images/plans/' + plan.image_name;
                // Add list location's objects properties to plan location's objects and opposite
                plan.location_plans = this.mergePlanAndListLocations(plan.location_plans);
                return plan;
              }
            );

          this.mapCenter = {
            lat: this.markers[0] ? this.markers[0].latitude : null,
            lng: this.markers[0] ? this.markers[0].longitude : null,
          };
          this.fitBounds = true;
          this.showSpinner = false;
          this.mapOpacity = 1;
        }
      );
  }

  switchView() {
    switch (this.selectedView) {
      case 2:
        if (this.selectedPlanIndex) {
          this.selectedView = 3;
        } else {
          this.selectedView = 1;
        }
        break;
      default:
        this.selectedView = 2;
        break;
    }
  }

  switchToPlan(planIndex) {
    this.selectedPlanIndex = planIndex;
    this.selectedView = 3;
  }

  switchToMap() {
    this.selectedPlanIndex = undefined;
    this.selectedView = 1;
  }

  toggleSelectedMarker(marker: AgmMarker | any, id: number, action: 'select' | 'unselect') {
    if (action === 'select') {
      this.selectMarker(marker, id);
    } else {
      this.unselectMarker();
    }
  }

  setMapCenter(coordinates: google.maps.LatLngLiteral) {
    this.currentMapCenter = coordinates;
  }

  addMarkerToMap(selectedMarker: any) {
    this.fitBounds = false;
    this.mapCenter = Object.assign({}, this.currentMapCenter);
    let index = this.markers.findIndex(
      (marker) => marker.id === selectedMarker.id
    );
    if (index > -1) {
      this.markers[index].latitude = this.mapCenter.lat;
      this.markers[index].longitude = this.mapCenter.lng;
    }

  }

  goToChart(marker) {
    this.router.navigate(['chart', this.idProject, marker.id]);
  }

  patchProjectDeviceLocation(event: google.maps.MouseEvent, marker) {
    this.fitBounds = false;
    this.mapCenter = Object.assign({}, this.currentMapCenter);
    let bodyParam: any = {
      latitude: event.latLng.lat(),
      longitude: event.latLng.lng()
    };
    this.projectService.patchProjectDeviceLocation(marker.id, bodyParam)
      .subscribe(
        () => this.initComponent()
      );
  }

  deleteProjectDeviceLocation(marker) {
    let bodyParam: any = {
      latitude: null,
      longitude: null
    };
    this.projectService.patchProjectDeviceLocation(marker.id, bodyParam)
      .subscribe(
        () => this.initComponent()
      );
  }

  toggleMap() {
    this.expanded = !this.expanded;
  }

  private selectMarker(selectedMarker: AgmMarker | any, id) {
    this.markers.forEach(
      (marker) => {
        if (marker.id === id) {
          marker.selected = true;
          marker.disabled = false;
        } else {
          marker.selected = false;
          marker.disabled = true;
        }
      }
    );
  }

  private unselectMarker() {
    this.markers.forEach(
      (marker) => {
        marker.selected = false;
        marker.disabled = false;
      }
    );
  }


  private mergePlanAndListLocations(planLocations) {
    return planLocations.reduce(
      (updatedPlanLocations, planLocation) => {
        if (!planLocation.active) {
          return updatedPlanLocations;
        }
        let i = this.markers.findIndex(
          (listLocation) => listLocation.id === planLocation.location_id);
        if (i === -1) {
          return updatedPlanLocations;
        }
        this.markers[i].location_plan_id = planLocation.id;   // Add the plan location ID to the marker object
        let updatedPlanLocation = Object.assign({}, this.markers[i], planLocation);
        return updatedPlanLocations.concat(updatedPlanLocation);
      }, []
    );
  }

}
